import { render, staticRenderFns } from "./ChbProductsForm.vue?vue&type=template&id=eeb39af6&scoped=true"
import script from "./ChbProductsForm.vue?vue&type=script&lang=js"
export * from "./ChbProductsForm.vue?vue&type=script&lang=js"
import style0 from "./ChbProductsForm.vue?vue&type=style&index=0&id=eeb39af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb39af6",
  null
  
)

export default component.exports